module.exports = __webpack_public_path__ + "static/img/businessMapBg.acca5ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/businessMapBg.png
// module id = vUQS
// module chunks = 0